module.exports = "https://r.nearpod.com/assets/media/image/arrow-create-icon-81fcc0a4ce4f11a7bfa408fb96e0b2dd.svg";